import { CommunitySwitcherProvider } from "@circleco/community-switcher/context/CommunitySwitcherContext";

import { useCommunitySwitcherAdapter } from "./useCommunitySwitcherAdapter";

export interface CommunitySwitcherWithPackageAdapterProps {
  isLoadingAppData?: boolean;
}

export const CommunitySwitcherWithPackageAdapter = ({
  isLoadingAppData = false,
}: CommunitySwitcherWithPackageAdapterProps) => {
  const { providerValue } = useCommunitySwitcherAdapter(isLoadingAppData);

  return <CommunitySwitcherProvider value={providerValue} />;
};
